/* global axios */
import ApiClient from '../ApiClient';

// The Max's script of one assistant (the scenario set): the set with its steps (nodes), the catalog the editor
// chooses from, importing a base script, saving one step, and the preview conversation over the draft.
class PolarisScenarioSet extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  path(assistantId) {
    return `${this.url}/${assistantId}/scenario_set`;
  }

  show(assistantId) {
    return axios.get(this.path(assistantId));
  }

  import(assistantId, key) {
    return axios.post(`${this.path(assistantId)}/import`, { key });
  }

  // `lockVersion` is the set's version the editor saw: an older one answers 409 (someone else saved first).
  updateNode(assistantId, id, { title, node, lockVersion }) {
    return axios.patch(`${this.url}/${assistantId}/scenario_nodes/${id}`, {
      title,
      node,
      lock_version: lockVersion,
    });
  }

  preview(assistantId, { messages, testingAs }) {
    return axios.post(`${this.path(assistantId)}/preview`, {
      messages,
      testing_as: testingAs,
    });
  }
}

export default new PolarisScenarioSet();
